import React from "react";
import { Popover } from "@vitalsource/vstui/labs";
import withViewer, { ViewerProps } from "../../viewer-context/withViewer";
import { POPOVER_V_OFFSET } from "../consts";
import BasicFormatting from "./BasicFormatting";
import EnhancedFormatting from "./EnhancedFormatting";
import { useIntl } from "react-intl";
import RoundBorderButton from "components/common/RoundButton/RoundBorderButton";

export const FormattingMenus = (props: ViewerProps) => {
  const intl = useIntl();

  let menu = <BasicFormatting {...props} />;
  let label = intl.formatMessage({ id: "format.zoomOptions" });
  if (props.bookData.format === "epub" && props.bookData.layout !== "fixed") {
    menu = <EnhancedFormatting {...props} />;
    label = intl.formatMessage({ id: "format.enhancedFormatting" });
  }

  return (
    <Popover
      modifiers={{
        offset: {
          offset: `0, ${POPOVER_V_OFFSET}px`,
        },
      }}
      placement="bottom-end"
      content={menu}
    >
      <RoundBorderButton fullWidth naked label={label} color="neutral">
        Aa
      </RoundBorderButton>
    </Popover>
  );
};

export default withViewer(FormattingMenus);
